// =============================================================================
// TimeGridHeader - Intestazione ore della griglia
// =============================================================================

import type { TimeGridHeaderProps } from '../types/scheduler.types';

export function TimeGridHeader({ hours }: TimeGridHeaderProps) {
  return (
    <div className="flex border-b border-gray-200 bg-gray-50 sticky top-0 z-10">
      {/* Colonna nomi risorse */}
      <div className="w-48 flex-shrink-0 p-2 border-r border-gray-200" />
      
      {/* Celle ore */}
      <div className="flex-1 flex">
        {hours.map((hour) => (
          <div
            key={hour}
            className="flex-1 text-center text-xs font-medium text-gray-500 py-2 border-r border-gray-100"
          >
            {String(hour).padStart(2, '0')}:00
          </div>
        ))}
      </div>
    </div>
  );
}
